var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("divider", { attrs: { label: "Dados do Processo" } }),
      _c(
        "div",
        { staticClass: "mt-1 padding-info-analise" },
        [
          _c(
            "el-row",
            { staticClass: "labelDiv" },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12, lg: 8 } },
                [
                  _c("div", { staticClass: "col" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Responsável:")
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.responsavel))])
                  ])
                ]
              ),
              _c("el-col", { attrs: { span: 12, lg: 8 } }, [
                _c("div", { staticClass: "col" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Cargo:")]),
                  _c("span", [_vm._v(_vm._s(_vm.cargo))])
                ])
              ]),
              _c("el-col", { attrs: { span: 12, lg: 4 } }, [
                _c("div", { staticClass: "col" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Data:")]),
                  _c("span", [_vm._v(_vm._s(_vm.dataFormatada))])
                ])
              ]),
              _c("el-col", { attrs: { span: 12, lg: 4 } }, [
                _c("div", { staticClass: "col" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("Hora:")]),
                  _c("span", [_vm._v(_vm._s(_vm.hora))])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a99389c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a99389c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/InformacoesAnalise.vue
// module id = null
// module chunks = 